import classNames from 'classnames'


export default function Pill({ children, color, className }) {
  let colorClasses = {
    green: 'bg-pill-green-light text-pill-green-light dark:bg-pill-green-dark dark:text-pill-green-dark font-semibold',
    red: 'bg-pill-red-light text-pill-red-light dark:bg-pill-red-dark dark:text-pill-red-dark font-semibold',
    orange: 'bg-pill-orange-light text-pill-orange-light dark:bg-pill-orange-dark dark:text-pill-orange-dark font-semibold',
  }
  let colorClass = colorClasses[color] || 'shadow dark:bg-neutral-900'
  return (
    <span 
      className={classNames(
        'w-fit max-w-full inline-flex px-2 shadow rounded-full whitespace-nowrap overflow-hidden text-ellipsis',
        colorClass, 
        className
      )}
    >{children}</span>
  )
}
